import { SET_ASSESSMENT_DATA, SET_ASSESSMENT_SUMMARY } from '../actions/actionTypes'

/**
 * Redux state for Assessment Status Indicators feature.
 *
 * perPhenomenon: {
 *   [phenomenonId]: {
 *     hasVotes:      boolean,
 *     hasRatings:    boolean,
 *     hasComments:   boolean,
 *     hasOwnVote:    boolean,
 *     hasOwnRating:  boolean,
 *     hasOwnComment: boolean,
 *   }
 * }
 *
 * summary: {
 *   voting: {
 *     registeredUsers: { usersDone, usersTotal, phenomenaDone, phenomenaTotal, actionsTotal },
 *     unknownUsers:    { phenomenaDone, phenomenaTotal, actionsTotal }
 *   },
 *   rating: { ... },
 *   commenting: { ... }
 * }
 */
const initialState = {
  perPhenomenon: {},
  summary: {},
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ASSESSMENT_DATA:
      return { ...state, perPhenomenon: payload }
    case SET_ASSESSMENT_SUMMARY:
      return { ...state, summary: payload }
    default:
      return state
  }
}
